// Put your applicaiton javascript here

/* window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  console.log(check)
  return check;
}; */

window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};


$(document).ready(function () {
  console.log('Theme js loaded')
  
  if (!mobileAndTabletCheck()) {
    $('.bract-logo-container').hide();
    $('.parallax-window').removeClass('home');
    $('.parallax-window').parallax({
      naturalWidth: 800,
      naturalHeight: 400,
      speed: 0.5
    });
  } else {
    // $('.parallax-slider').show();
    $('.banner').css('height', '1000px');
    $('.bract-logo-container').hide();
  }
  
  $('.featured-collection-grid').scrollLeft(1000)

  // Main burger menu animations
  $('#burger-menu').on('click', function () {
    if (!$(this).hasClass('active')) {
      // Menu has opened
      $(this).addClass('active')
      $('.nav-menu, body').addClass('active')
      $('.nav-menu').find('.content').addClass('active')
      $('.nav-menu').find('.social-links').addClass('active')
    } else {
      // Menu has closed
      $(this).removeClass('active')
      $('.nav-menu, body').removeClass('active')
      $('.nav-menu').find('.content').removeClass('active')
      $('.nav-menu').find('.social-links').removeClass('active')
    }
  })

  $('.nav-menu')
    .on('click', function (e) {
      if (e.target !== this) return
      else {
        // Close Menu and hide all contents if overlay clicked
        if ($(this).hasClass('active')) {
          $('.nav-menu, body').removeClass('active')
          $('.nav-menu').find('.content').removeClass('active')
          $('.nav-menu').find('.social-links').removeClass('active')
          $('#burger-menu').removeClass('active')
        }
      }
    })
    .children()
    .click(function (e) {
      e.stopPropagation
    })

  // Sub menu animation
  $('.item.has-children, .menu.has-children').on('click', function () {
    if (!$(this).hasClass('active')) {
      $(this).addClass('active')
      $(this).find('.sub-content').addClass('active')
    } else {
      $(this).removeClass('active')
      $(this).find('.sub-content').removeClass('active')
    }
  })

  // Product page description animation
  $('#read-more').on('click', function () {
    if (!$('.product-desc').hasClass('show')) {
      $('.product-desc').addClass('show')
      $(this).text(' Read Less')
    } else {
      $('.product-desc').removeClass('show')
      $(this).text(' Read More')
    }
  })

  $(window).scroll(function (event) {
    var scroll = $(window).scrollTop()
    if (scroll > 300) {
      /* --- About Section Fade In --- */
      if (!$('content-text-body').is('#slide-up')) {
        $('.content-text-body').attr('id', 'slide-up')
      }
      if (!$('content-text-heading').is('#slide-up')) {
        $('.content-text-heading').attr('id', 'slide-up')
      }

    //   /* --- Mobile Nav Menu Toggle Fade Out --- */
    //   if (!$('logo-container').hasClass('toggle-visibility')) {
    //     $('.logo-container').addClass('toggle-visibility')
    //   }
    //   if (!$('side').hasClass('toggle-visibility')) {
    //     $('.side').addClass('toggle-visibility')
    //   }
    // } else if (scroll < 300) {
    //   /* --- Mobile Nav Menu Toggle Fade In --- */
    //   if ($('.logo-container').hasClass('toggle-visibility')) {
    //     $('.logo-container').removeClass('toggle-visibility')
    //   }
    //   if ($('.side').hasClass('toggle-visibility')) {
    //     $('.side').removeClass('toggle-visibility')
    //   }
    }
  })

  $('.welcome-link, .shop-link, .blog-link').on('click', function () {
    var nextSection = document.getElementById('next-section')
    nextSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })
  })
  var lastScrollTop = 0;
  $(window).scroll(function(event){
    var bractHeight = $('#bract-image').height()
    
    var st = $(this).scrollTop();
    var scrollDifference = st - lastScrollTop
    $('#bract-image').height(bractHeight + (0.02 * scrollDifference))
     lastScrollTop = st;
  });
  
  $(".right-arrow").on('right click', function () {
    // console.log('right clicked')
    var screenSize = $( window ).width()/3.8;
    var scrollPos = $('.featured-collection-grid').scrollLeft()
    if(scrollPos - parseInt(screenSize) <= 1990) {
      $('.featured-collection-grid').animate({ scrollLeft:`+=${screenSize}` }, 500, 'swing');
    }
  })
  
  $(".left-arrow").on('click', function () {
    // console.log('left clicked')
    // var screenSize = $('.featured-collection-grid').width()/2.5;
    var screenSize = $( window ).width()/3.8;
    var scrollPos = $('.featured-collection-grid').scrollLeft()
    if(scrollPos + parseInt(screenSize) >= 535) {
      $('.featured-collection-grid').animate({ scrollLeft:`-=${screenSize}` }, 500, 'swing');
    }   
  })
})